import { Button } from "antd";
import { complexDigitToman, isEmptyObject } from "../../../tools/tools";
import { useEffect, useState } from "react";
import { useReport } from "../../../tools/api";
import PieChart from "./PieChart/PieChart";

const SaleStatistics = () => {
  const { statisticalReportProductCommissionSales } = useReport();
  const [commission, setCommission] = useState({});
  useEffect(() => {
    const initialServ = async () => {
      const statistCommission = await statisticalReportProductCommissionSales();
      if (statistCommission && !statistCommission?.HasError) {
        setCommission(statistCommission.Result);
      }
    };
    initialServ();
  }, []);
  return (
    <>
      <div className="holder-sales">
        <div className="holder-box sales">
          <div className="overly"></div>
          <div className="box-text">
            <div className="head-title">
              <div className="hold-text">{/* <h3>آمار فروش</h3> */}</div>
              <div className="body-text">
                <span>مجموع فروش</span>
                <h3>
                  <span>{complexDigitToman(Math.abs(commission?.spPurchaseSales + commission?.packageSales + commission?.chargeSales))}</span> تومان
                </h3>
              </div>
              <div className="holder-box-sales">
                <div className="item-box">
                  <div className="holder-icon">
                    <div className="hold red">
                      <i className="icon-packages1"></i>
                    </div>
                  </div>
                  <div className="title">مجموع فروش سیم‌کارت</div>
                  <div className="price">
                    <span dir="ltr">{complexDigitToman(Math.abs(commission?.spPurchaseSales))}</span> تومان
                  </div>
                </div>
                <div className="item-box">
                  <div className="holder-icon">
                    <div className="hold green">
                      <i className="icon-invoice"></i>
                    </div>
                  </div>
                  <div className="title">مجموع فروش بسته</div>
                  <div className="price">
                    <span dir="ltr">{complexDigitToman(Math.abs(commission?.packageSales))}</span> تومان
                  </div>
                </div>
                <div className="item-box">
                  <div className="holder-icon">
                    <div className="hold blue">
                      <i className="icon-simcard1"></i>
                    </div>
                  </div>
                  <div className="title">مجموع فروش شارژ</div>
                  <div className="price">
                    <span dir="ltr">{complexDigitToman(Math.abs(commission?.chargeSales))}</span> تومان
                  </div>
                </div>
              </div>
              <div className="holder-box-pie-chart">{!isEmptyObject(commission) && <PieChart usageChart={commission} />}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SaleStatistics;
